<template>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="framework/html_behaviors/bs-tooltip"></require>
  <require from="controls/as-page-header"></require>
  <require from="controls/as-form-skeleton"></require>
  <require from="components/travel-request-form"></require>

  <div class="travel-request-detail-screen">
    <form class="container-fluid">
      <as-page-header heading.bind="title" display-heading-on-mobile.bind="!headerButtonsVisible" is-mobile-app-cancel.bind="id == null">
        <div class="d-flex align-items-center" slot="aside" if.bind="loaded">
          <div class="text-nowrap ${headerButtonsVisible ? 'mr-3' : ''}" title="${statusTooltip}" if.bind="model.status && !editing" bs-tooltip>
            <span class="d-none d-sm-inline at-approval-status ${statusClass}">${model.status.name}</span>
            <i class="ai-approval-status ${statusClass}"></i>
          </div>
          <div class="sc-buttons-container text-nowrap">
            <!--<button type="button" class="btn btn-warning" af-mutex-click.call="applicableDeviations()" if.bind="applicableDeviationsButtonVisible">
    <i class="fas fa-clipboard-check"></i> Applicable Deviations
  </button>-->
            <button type="button" class="btn btn-warning ${requireMoreInfo ? 'sc-pulse-warning' : ''}" af-mutex-click.call="edit()" if.bind="editButtonVisible">
              <i class="fas fa-edit"></i><span class="d-none d-sm-inline-block ml-1">Edit Request</span><span class="d-inline-block d-sm-none ml-1">Edit</span>
            </button>
            <button type="button" class="btn btn-danger" af-mutex-click.call="archive()" if.bind="archiveButtonVisible" title="Click to archive this request" bs-tooltip>
              <i class="fas fa-trash"></i>
            </button>
            <button type="button" class="btn btn-success" af-mutex-click.call="restore()" if.bind="restoreButtonVisible" title="Click to restore this request" bs-tooltip>
              <i class="fas fa-trash-restore"></i>
            </button>
            <button type="submit" class="btn btn-primary" af-mutex-click.call="submit()" if.bind="submitButtonVisible">
              <i class="fas fa-paper-plane"></i><span class="d-none d-sm-inline-block ml-1">${id ? 'Resubmit Request' : 'Submit Request'}</span><span class="d-inline-block d-sm-none ml-1">${id ? 'Resubmit' : 'Submit'}</span>
            </button>
            <button type="button" class="btn btn-light" af-mutex-click.call="cancel()" if.bind="cancelButtonVisible">
              <i class="fas fa-times"></i><span class="d-inline-block ml-1">${id ? 'Cancel' : 'Reset'}</span>
            </button>
          </div>
        </div>
      </as-page-header>
      <travel-request-form class="sc-content-appear" view-model.ref="form" model.bind="model" permissions.bind="permissions" attachments-controller.bind="attachmentsController" history.bind="history" autofocus.bind="!id" disabled.bind="!editing" changed.bind="changed" is-any-approvable-country.bind="isAnyApprovableCountry" debug="true" if.bind="loaded"></travel-request-form>
      <as-form-skeleton else></as-form-skeleton>
    </form>
  </div>
</template>
